import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id 02D856A6-74E6-41EA-8938-054DD39B627D
 * name octagram-edit-outline
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/octagram-edit-outline.svg
 * tags
 * - Shape 
 */
export const OctagramEditOutlineIcon = createSvgIcon(<><path d="M3.88 12L2.2 16.06L6.26 17.74L7.94 21.8L11 20.53V18.36L9 19.19L7.79 16.21L4.81 15L6.05 12L4.81 9L7.79 7.79L9 4.81L12 6.05L15 4.81L16.21 7.79L19.19 9L17.95 12L18 12.13L19.38 10.75C19.82 10.3 20.38 10.06 20.94 10L21.8 7.94L17.74 6.26L16.06 2.2L12 3.88L7.94 2.2L6.26 6.26L2.2 7.94L3.88 12M22.85 13.47L21.53 12.15C21.33 11.95 21 11.95 20.81 12.15L19.83 13.13L21.87 15.17L22.85 14.19C23.05 14 23.05 13.67 22.85 13.47M13 19.96V22H15.04L21.17 15.88L19.13 13.83L13 19.96Z" /></>, 'OctagramEditOutlineIcon');
export default OctagramEditOutlineIcon